import { render, staticRenderFns } from "./PushNotifications.vue?vue&type=template&id=b118fc64"
import script from "./PushNotifications.vue?vue&type=script&lang=js"
export * from "./PushNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports